// export const API_URL = "http://localhost:5011";
export const API_URL = "https://api.answersai.com";
